
export const closest = (elem: HTMLElement, selector: string): HTMLElement => {

    if (!elem) {
        return undefined;
    } else if (elem.matches(selector)) {
        return elem;
    } else if (elem.parentElement) {
        return closest(elem.parentElement, selector);
    }
    return undefined;
};



// WEBPACK FOOTER //
// ./src/core/util/closest.ts